import type { Timeframe } from '@shared/types/candle'
import { useEffect, useRef, useState } from 'react'

import { IST_OFFSET, type OhlcvBar } from '@/hooks/useCandles'
import { wsService } from '@/services/websocket'

export function useLiveCandle(symbol: string, timeframe: Timeframe): OhlcvBar | null {
  const [bar, setBar] = useState<OhlcvBar | null>(null)
  const symRef = useRef(symbol)
  const tfRef = useRef(timeframe)
  symRef.current = symbol
  tfRef.current = timeframe

  useEffect(() => {
    if (!symbol) return

    wsService.connect()
    wsService.subscribe([symbol], ['candle'], [timeframe])

    const off = wsService.on((msg) => {
      if (
        msg.type === 'candle' &&
        msg.symbol === symRef.current &&
        msg.timeframe === tfRef.current
      ) {
        const { t, o, h, l, c, v } = msg.data
        setBar({ time: t + IST_OFFSET, open: o, high: h, low: l, close: c, value: v })
      }
    })

    return () => {
      off()
      wsService.unsubscribe([symbol])
    }
  }, [symbol, timeframe])

  useEffect(() => {
    setBar(null)
  }, [symbol, timeframe])

  return bar
}
